import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Outlet, ScrollRestoration } from 'react-router-dom';

import ResultContextProvider from './features/dashboard/store/ResultContextProvider';
import SurveyContextProvider from './features/survey/store/SurveyContextProvider';
import HeaderBar from './shared/components/header/HeaderBar';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});

const {
  window: {
    __RUNTIME_CONFIG__: { DEV_MODE },
  },
} = globalThis;

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ResultContextProvider>
      <SurveyContextProvider>
        <HeaderBar />
        <Outlet />
        <ScrollRestoration />
      </SurveyContextProvider>
    </ResultContextProvider>
    {DEV_MODE === 'true' && <ReactQueryDevtools initialIsOpen={false} />}
  </QueryClientProvider>
);

export default App;
